import { Property } from "../contexts/properties/logic";

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function getMonths(property?: Property): string[] {
    if(property) {
        if(property.fiscalYearStartMonthIndex !== 0){
            const startOfArr = months.slice(property.fiscalYearStartMonthIndex);
            const endOfArr = months.slice(0, property.fiscalYearStartMonthIndex);
            return [...startOfArr, ...endOfArr];
        } else if(property.isAcquisitionProperty && property.acquisitionBudgetStartMonth) {
            const startOfArr = months.slice(property.acquisitionBudgetStartMonth);
            const endOfArr = months.slice(0, property.acquisitionBudgetStartMonth);
            return [...startOfArr, ...endOfArr];
        }
    }
    return [...months];
}

export function getLongMonths(property?: Property): string[] {
    if(property) {
        if(property.fiscalYearStartMonthIndex !== 0){
            const startOfArr = longMonths.slice(property.fiscalYearStartMonthIndex);
            const endOfArr = longMonths.slice(0, property.fiscalYearStartMonthIndex);
            return [...startOfArr, ...endOfArr];
        } else if(property.isAcquisitionProperty && property.acquisitionBudgetStartMonth) {
            const startOfArr = longMonths.slice(property.acquisitionBudgetStartMonth);
            const endOfArr = longMonths.slice(0, property.acquisitionBudgetStartMonth);
            return [...startOfArr, ...endOfArr];
        }
    }
    return [...longMonths];
}

export function getMonthIndexes(property?: Property): number[] {
    const monthIndexes = Array.from({ length: 12 }, (_, index) => index);
    if(property){
        if(property.fiscalYearStartMonthIndex !== 0){
            const startOfArr = monthIndexes.slice(property.fiscalYearStartMonthIndex);
            const endOfArr = monthIndexes.slice(0, property.fiscalYearStartMonthIndex);
            return [...startOfArr, ...endOfArr];
        }
        else if(property.isAcquisitionProperty && property.acquisitionBudgetStartMonth){
            const startOfArr = monthIndexes.slice(property.acquisitionBudgetStartMonth);
            const endOfArr = monthIndexes.slice(0, property.acquisitionBudgetStartMonth);
            return [...startOfArr, ...endOfArr];
        }
    }
    return [...monthIndexes];
}

export function getLastDayOfMonth(month: number, year: number): number {
    // We add one here because using this JS trick requires that we use
    // the next month to get the last day.
    // (i.e. 2025-02-00 maps to 2025-01-31)
    return new Date(year, month + 1, 0).getDate();
}
